export default {
  getDriedCookingProcessCheck: (state) => state.driedCookingProcessCheck,
};
